var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_vm._v("\n  "+_vm._s(this.formatedNumber(
      _vm.model[_vm.firstAttribute] >= _vm.alreadySend
        ? _vm.model[_vm.firstAttribute]
        : _vm.alreadySend
    ))+"\n  / "+_vm._s(this.formatedNumber(_vm.model[_vm.secondAttribute]))+" |\n  "+_vm._s(Math.round(
      ((_vm.model[_vm.firstAttribute] >= _vm.alreadySend
        ? _vm.model[_vm.firstAttribute]
        : _vm.alreadySend) /
        _vm.model[_vm.secondAttribute]) *
        100,
      2
    ))+"%\n  "),_c('div',{staticClass:"progress-box"},[_c('div',{staticClass:"progress-bar progress circular-send-progress",style:('width: ' +
          Math.round(
            ((_vm.model[_vm.firstAttribute] >= _vm.alreadySend
              ? _vm.model[_vm.firstAttribute]
              : _vm.alreadySend) /
              _vm.model[_vm.secondAttribute]) *
              100,
            2
          ) +
          '%'),attrs:{"role":"progressbar","aria-valuenow":Math.round(
          ((_vm.model[_vm.firstAttribute] >= _vm.alreadySend
            ? _vm.model[_vm.firstAttribute]
            : _vm.alreadySend) /
            _vm.model[_vm.secondAttribute]) *
            100,
          2
        ),"aria-valuemin":"0","aria-valuemax":"100"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }